// think of renaming to SearchQueryParameters
export class SearchParametersConst {
	public static readonly townFromId = 'from';
	public static readonly stateId = 'to';
	public static readonly townIds = 'town';
	public static readonly checkInBegin = 'begin';
	public static readonly checkInEnd = 'end';
	public static readonly nights = 'nights';
	public static readonly adult = 'adult';
	public static readonly child = 'child';
	public static readonly childAges = 'ages';
	public static readonly currencyId = 'currency';
	public static readonly starIds = 'stars';
	public static readonly serviceIds = 'services';
	public static readonly hotelTypeIds = 'hotelTypes';
	public static readonly roomTypeIds = 'room';
	public static readonly hotelIds = 'hotels';
	public static readonly priceFrom = 'priceFrom';
	public static readonly priceTo = 'priceTo';
	public static readonly sort = 'sort';
	public static readonly filter = 'filter';
}
